import { Box, Button, TextField, Typography } from "@mui/material";
import { getDatabase, onValue, push, ref } from "firebase/database";
import { useEffect, useRef, useState } from "react";

export const ChatWindow = ({ conversation, userType }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);
  const database = getDatabase();

  useEffect(() => {
    const messagesRef = ref(database, 'messages/' + conversation.ticket_id);

    return onValue(messagesRef, snapshot => {
      const data = snapshot.val();
      const list = data
        ? Object.entries(data).map(([id, v]) => ({ id, ...v }))
        : [];
      setMessages(list);
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    });
  }, [conversation.ticket_id]);

  const sendMessage = async () => {
    if (!newMessage.trim()) return;

    const messagesRef = ref(database, 'messages/' + conversation.ticket_id);
    await push(messagesRef, {
      sender_type: userType,
      message_content: newMessage,
      timestamp: new Date().toISOString()
    });

    setNewMessage('');
  };

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ p: 2, borderBottom: '1px solid #ddd' }}>
        <Typography fontWeight="bold">{conversation.username || conversation.ticket_id}</Typography>
      </Box>

      {/* Messages */}
      <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
        {messages.map(msg => (
          <Box
            key={msg.id}
            sx={{
              mb: 1,
              display: 'flex',
              justifyContent: msg.sender_type === userType ? 'flex-end' : 'flex-start'
            }}
          >
            <Box sx={{ p: 1, borderRadius: 1, bgcolor: '#e3f2fd', maxWidth: '70%' }}>
              {msg.message_content}
            </Box>
          </Box>
        ))}
        <div ref={messagesEndRef} />
      </Box>

      {/* Input */}
      <Box sx={{ p: 2, display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
          placeholder="Type a message"
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
        />
        <Button variant="contained" onClick={sendMessage}>Send</Button>
      </Box>
    </Box>
  );
};
